import qs from 'qs'

export const APPOINTMENTS = '/appointments'
export const SUPPORT_APPOINTMENTS = '/appointments/support'
export const PATIENT = '/patients'
export const PATIENT_SUPPORT = '/support/patients'
export const USER_SUPPORT = '/support/users'
export const PATIENT_REQ_CONSENT = '/patients/request-consent'
export const PAYMENT_SUBCRIPTION = '/appointments/subscription'
export const PATIENT_CARE_STATUS = '/patients/care-status'
export const WAIVE_PAUSE_ENROLLMENT = '/appointments/waive-pause-enrollment'
export const INSURANCE_INQUIRY = '/insurance-inquiry/'
export const PATIENT_CREATE_RP_AND_PATIENTS =
  '/patients/create-patient-and-user-in-tc'
export const PATIENT_TASKS_FORM_RESPONSES = '/patient-tasks/form-responses'
export const PATIENT_LOGIN_AUDIT = '/auth/sessions'
export const PATIENT_SESSION_DISABLE = '/auth/session/disable'
// Remove these two when not needed after split removal
export const WAIVE_LATE_CANCELLATION_REASONS =
  '/appointments/waive-late-cancelation-reasons'
export const CANCELATION_REASONS = '/appointments/cancelation-reasons'
export const RED_ALERT_SUPPORT_TICKETS = '/red-alert/support-tickets'

export const APPOINTMENT_CANCELATION_REASONS =
  '/appointments/appointment-cancelation-reasons'

export const getUserDecisionRoute = (insuranceInquiryAuditId: string): string =>
  `${INSURANCE_INQUIRY}${insuranceInquiryAuditId}/choose-decision`

export const getSupportCancelationReasons = (
  appointmentStartTime: string
): string =>
  `${APPOINTMENT_CANCELATION_REASONS}?startDate=${appointmentStartTime}`

export const validateAndGetUserDetailsRoute = (
  userId: string,
  email: string
): string =>
  `support/users/${userId}/allow-booking-flow?email=${encodeURIComponent(
    email
  )}`

export const getProductDetailsRoute = (id: string): string =>
  `/payments/products/${id}/prices`
export const cancelAppointmentRoute = (
  appointmentEhrId: string | number
): string => `appointments/${appointmentEhrId}/cancel`
export const rescheduleAppointmentRoute = (
  appointmentEhrId: string | number
): string => `/appointments/${appointmentEhrId}/reschedule`
export const updatePatientDetailsRoute = (id: string): string =>
  `${PATIENT}/${id}`
export const updatePatientDemographicsRoute = (id: string): string =>
  `${PATIENT_SUPPORT}/${id}`
export const updateUserDemographicsRoute = (id: string): string =>
  `${USER_SUPPORT}/${id}`
export const getPatientDetailsRoute = (id: string, userId: string): string =>
  `${PATIENT}/${id}?userId=${userId}`
export const getPhoneNumberValidationRoute = (number: string): string =>
  `/notifications/phone-number/${number}/lookup`
export const getPatientsforSupportUser = (id: string): string =>
  `${PATIENT}?userId=${id}`

export const getCancelEnrollmentRoute = (id: string): string =>
  `${PAYMENT_SUBCRIPTION}?userId=${id}`
export const getBillingDetailsRoute = (id: string): string =>
  `/payments/${id}/transactions`
export const getRefundRoute = (id: string): string => `/payments/${id}/refund`
export const getReattemptRoute = (id: string): string => `/payments/${id}/retry`
export const getAppointmentsWithAProvider = (
  patientId: string,
  providerId: string
): string => `/appointments/provider/${providerId}/patient/${patientId}`
export const getAppointmentRebookingRoute = (ehrId: string | number): string =>
  `/appointments/rebook/${ehrId}`
export const getInsuranceValidityRoute = ({
  insuranceId,
  patientId,
  providerId,
  practiceId,
  auditId,
}: GetInsuranceValidityRouteParams): string =>
  `/insurance-inquiry/validate/patient/${patientId}/insurance/${insuranceId}/provider/${providerId}/practice/${practiceId}${
    auditId ? `?auditId=${auditId}` : ''
  }`

export const getBillingHistoryRoute = (
  patientId: string,
  { startDate, endDate }: Record<string, string>
): string =>
  `/patients/${patientId}/billing-history?startDate=${startDate}&endDate=${endDate}`

export const getBillingTransactionRoute = (
  patientId: string,
  visitEhrId: string | number
): string => `/patients/${patientId}/billing-history/${visitEhrId}`

export const getBillingBalancePaymentRoute = (patientId: string): string =>
  `/payments/${patientId}/pay`

export const getAppointmentsWithProviderForCounselling = (
  patientId: string,
  providerId: string,
  counselingTypeId: string
): string =>
  `/appointments/patient/${patientId}/provider/${providerId}/counselling-type/${counselingTypeId}/exists`
export const getLateCancellationFeesAndWindowRoute = `/appointments/late-cancelation-window-and-fee`

export const getCareStatus = (patients: PatientInfo[]): string => {
  const queryParamString = qs.stringify(
    { patientIds: patients.map((patient) => patient.id) },
    { addQueryPrefix: true }
  )
  return PATIENT_CARE_STATUS + queryParamString
}

export const patientAuthorizationsRoute = (primaryPatientId: string): string =>
  `${PATIENT}/${primaryPatientId}/authorizations`

export const getPatientAppointmentsRoute = (ehrId: string | number): string =>
  `/appointments/patient/${ehrId}`
